import BlTabsMv from './BlTabsMv.vue'

BlTabsMv.install = function(Vue) {
  Vue.component(BlTabsMv.name, BlTabsMv)
}

export default BlTabsMv
